import { ExclamationTriangleIcon } from "@heroicons/react/24/outline"
import React from "react"

import { Button } from "../../../components/shared/Buttons"

import { emptyConflictWarning } from "./selectors"
import { CalendarConnectionSummary } from "./types"

interface Props {
  connection: CalendarConnectionSummary
  onEditConflicts: (connection: CalendarConnectionSummary) => void
}

const EmptyConflictBanner = ({ connection, onEditConflicts }: Props) => {
  const message = emptyConflictWarning(connection)
  if (!message) return null

  return (
    <div className="mt-3 flex flex-wrap items-center gap-3 rounded-lg border border-yellow bg-yellow/10 p-3">
      <ExclamationTriangleIcon className="size-5 flex-none text-yellow" aria-hidden="true" />
      <div className="min-w-0 flex-1 text-sm">{message}</div>
      <Button
        onClick={() => onEditConflicts(connection)}
        type="secondary"
        className=""
        floatingInMobile={false}
        style={{}}>
        Edit
      </Button>
    </div>
  )
}

export default EmptyConflictBanner
